import { BiBuildings as EixosIcon } from 'react-icons/bi'

import { Eixo, PermissaoTipo } from '@core/models/entities'
import { useAuth, useFetch } from '@presentation/hooks'
import { TablePage } from '@presentation/components/templates'
import { PageProps } from '@presentation/types/components/templates'
import {
  Filter,
  FilterProps,
  TableColumn,
  TableProps
} from '@presentation/types/components/organisms'

import {
  AddEixoModal,
  DeleteEixoModal,
  EditEixoModal,
  ReactivateEixoModal
} from './components'

const EixosPage: React.FC = () => {
  const { hasPermission } = useAuth()
  const { data, isFetching, totalItems, fetchData } = useFetch({
    path: '/eixos',
    options: { sortBy: 'nome' },
    queries: {
      status: 1
    }
  })

  const pageConfigs: PageProps = {
    icon: <EixosIcon />,
    title: 'Eixos',
    description: 'Página de gerenciamento de eixos do campus.',
    actions: hasPermission(PermissaoTipo.Escrita)
      ? [<AddEixoModal onAdd={fetchData} />]
      : []
  }

  const filters: Filter[] = [
    {
      type: {
        value: 'nome',
        label: 'Nome'
      },
      description: {
        type: 'input',
        configs: {
          type: 'text'
        }
      }
    }
  ]

  const filterConfigs: FilterProps = {
    filters,
    fetchData,
    defaultQueries: {
      status: 1
    }
  }

  const columns: Array<TableColumn<Eixo>> = [
    {
      name: 'Nome',
      selector: eixo => eixo.nome,
      sortable: true,
      center: true,
      grow: 4
    },
    {
      name: 'Ações',
      cell: eixo => (
        <>
          {eixo.status ? (
            <>
              {hasPermission(PermissaoTipo.Escrita) && (
                <EditEixoModal id={eixo.id} onEdit={fetchData} />
              )}
              {hasPermission(PermissaoTipo.Remocao) && (
                <DeleteEixoModal id={eixo.id} onDelete={fetchData} />
              )}
            </>
          ) : (
            <>
              {hasPermission(PermissaoTipo.Escrita) && (
                <ReactivateEixoModal id={eixo.id} onReactivate={fetchData} />
              )}
            </>
          )}
        </>
      ),
      center: true
    }
  ]

  const tableConfigs: TableProps = {
    columns,
    data,
    apiConfigs: {
      totalItems,
      fetchData,
      isFetching
    }
  }

  return (
    <TablePage
      pageConfigs={pageConfigs}
      filterConfigs={filterConfigs}
      tableConfigs={tableConfigs}
    />
  )
}

export default EixosPage
